import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import AuthBoxedLayout from "../../components/Auth/AuthBoxedLayout";
import AuthField from "../../components/Auth/AuthField";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function RecoverPassword() {
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);
	const [sent, setSent] = useState(false);

	const handlSubmit = async (e) => {
		e.preventDefault();
		const emailTrim = email.trim().toLowerCase();
		if (!emailTrim || !EMAIL_REGEX.test(emailTrim)) {
			toast.error(i18n.t("recoverPassword.form.emailInvalid"));
			return;
		}
		setLoading(true);
		try {
			await api.post("/auth/forgot-password", { email: emailTrim });
			setSent(true);
			toast.success(i18n.t("recoverPassword.toasts.emailSent"));
		} catch (err) {
			toastError(err);
		}
		setLoading(false);
	};

	return (
		<AuthBoxedLayout
			testId="recover-password-page"
			title={i18n.t("recoverPassword.title")}
			titleClassName="text-primary"
		>
			<div className="p-3 mb-6 text-sm text-warning rounded-md bg-warning/15 border border-warning/20">
				{sent
					? i18n.t("recoverPassword.toasts.checkInbox")
					: i18n.t("recoverPassword.subTitle")}
			</div>

			<form noValidate onSubmit={handlSubmit}>
				<AuthField
					id="email"
					label={i18n.t("recoverPassword.form.email")}
				>
					<input
						type="email"
						id="email"
						name="email"
						className="form-input"
						placeholder={i18n.t("recoverPassword.form.emailPlaceholder")}
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						autoComplete="email"
						autoFocus
						required
						disabled={sent}
					/>
				</AuthField>

				<div className="mt-6 text-center">
					<button
						type="submit"
						className="btn bg-primary text-white w-full disabled:opacity-60"
						disabled={loading || sent}
					>
						{i18n.t("recoverPassword.buttons.submit")}
					</button>
				</div>

				<div className="mt-6 text-center">
					<p className="text-base text-default-800">
						<RouterLink
							to="/login"
							className="text-primary font-semibold underline hover:text-primary/80"
						>
							{i18n.t("recoverPassword.buttons.return")}
						</RouterLink>
					</p>
				</div>
			</form>
		</AuthBoxedLayout>
	);
}

export default RecoverPassword;
